function initCollectionSlider() {
  document.querySelectorAll('.collectionSwiper').forEach(function (slider) {
    if (slider.classList.contains('swiper-initialized')) return;

    new Swiper(slider, {
  loop: false,
  centeredSlides: false,
  watchOverflow: true,

  freeMode: {
    enabled: true,
    sticky: false
  },

  momentumRatio: 0.85,

  spaceBetween: 16,

  navigation: {
    nextEl: slider.querySelector('.swiper-button-next'),
    prevEl: slider.querySelector('.swiper-button-prev'),
  },

  breakpoints: {
    320: {
      slidesPerView: 1.15,
      spaceBetween: 10
    },
    480: {
      slidesPerView: 1.3,
      spaceBetween: 14
    },
    768: {
      slidesPerView: 2.3,
      spaceBetween: 16
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
      freeMode: false // snap on desktop
    }
  }
});

  });
}

document.addEventListener('DOMContentLoaded', initCollectionSlider);
document.addEventListener('shopify:section:load', initCollectionSlider);